
const init = () => {
  $('.js-collapse').click((e) => {
    $(e.currentTarget).next('div').slideToggle(200);
    $(e.currentTarget).toggleClass('open');
  });

  $('.js-collapse-single').click((e) => {
    const currentTarget = $(e.currentTarget);
    $('.js-collapse-single').not(currentTarget).removeClass('open').next('div').slideUp(200);
    currentTarget.toggleClass('open').next('div').slideToggle(200);
  });
  /*
  * Scroll to the anchor link and expand it
  */
  if (window.location.href.indexOf("#vraag-") > -1) {
    var hash = "#"+window.location.hash.substr(1);
    var menuHeight = $('.main-header').height() + $('.header-bar__notice').height() + 5;
    $('html,body').animate({scrollTop: $(hash).offset().top-menuHeight},'slow');
    $(hash+' .faq-list__question').next('div').slideToggle(200);
    $(hash+' .faq-list__question').toggleClass('open');
  }
  /*
  * Add a hash to the url to reference it as anchor link
  */
  $('.faq-list__question').click((e) => {
    e.preventDefault();
    window.history.pushState(null, null, window.location.pathname+'#'+$(e.currentTarget).parent().attr('id'));
  });
};

export default {
  init: init,
};
